import { useState, useEffect } from 'react';

export const useOAuthClientForm = (initForm) => {
  const [form, setForm] = useState(initForm);
  const [imgPreview, setImgPreview] = useState(null);

  const handleChangeForm = (key, converter) => (value) => {
    if (key === 'oauth_client_image') {
      const fileInfo = converter(value);
      const fileURL = window.URL.createObjectURL(fileInfo);
      setImgPreview(fileURL);
    }
    const v = converter ? converter(value) : value;
    setForm({ ...form, [key]: v });
  };

  useEffect(() => setForm(initForm), [initForm]);

  return { form, setForm, handleChangeForm, imgPreview };
};
